import { render, staticRenderFns } from "./EmergencyprocessFormHeader.vue?vue&type=template&id=74b5cd15"
import script from "./EmergencyprocessFormHeader.vue?vue&type=script&lang=js"
export * from "./EmergencyprocessFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports